
export enum WebHookOAuthAuthenticationType {
    Undefined = 0,
    NoOAuth = 1,
    ClientSecret = 2,
    ClientCredentialsCertificate = 3
}
